import React from 'react'

import { Row } from '@vividseats/vivid-ui-kit'

import QuantityButton from './components/quantity-button'
import styles from './styles.module.scss'

const FiltersQuantity: React.FC = () => (
    <Row className={styles.numberOfTicketsRow} wrap={true}>
        <Row justify="between" className={styles.buttonRow}>
            <QuantityButton label="1" quantity={1} />
            <QuantityButton label="2" quantity={2} />
            <QuantityButton label="3" quantity={3} />
            <QuantityButton label="4" quantity={4} />
        </Row>
        <Row justify="between" className={styles.buttonRow}>
            <QuantityButton label="5" quantity={5} />
            <QuantityButton label="6" quantity={6} />
            <QuantityButton label="7" quantity={7} />
            <QuantityButton label="8+" quantity={8} />
        </Row>
    </Row>
)

export default FiltersQuantity
